<template>
  <div class="copyright">
    <div class="copyright-nav__list">
      <a class="copyright-nav__item" target="_blank" :href="`/index` | hostBuild('corp')">About YorkBBS</a>
      <a class="copyright-nav__item" target="_blank" :href="`/aboutus` | hostBuild('corp')">关于我们</a>
      <a class="copyright-nav__item" target="_blank" :href="`/ads` | hostBuild('corp')">广告服务</a>
      <a class="copyright-nav__item" target="_blank" :href="`/concat` | hostBuild('corp')">联系方式</a>
      <a class="copyright-nav__item" href="mailto:marketing@yorkbbs.ca">媒体合作</a>
      <a class="copyright-nav__item" target="_blank" :href="`/policy` | hostBuild('corp')">免责声明</a>
      <a class="copyright-nav__item" target="_blank" :href="`/maps` | hostBuild('corp')">网站导航</a>
      <a class="footer-nav__item" :href="`/privacy.html` | hostBuild('www')" target="_blank">隐私权政策</a>
    </div>
    <div class="copyright-detail">Copyright © 2002-{{ nowYear }} Yorkbbs.ca 约克论坛 版权所有</div>
  </div>
</template>
<script>
export default {
  name: 'FooterSimple',
  components: {},
  data() {
    return {
      nowYear: new Date().getFullYear(),
    };
  },
};
</script>
<style lang="scss" scoped>
.copyright {
  text-align: center;
  padding: 50px 0;
  color: #333;
  font-size: 12px;
  line-height: 24px;
}
.copyright-nav__item {
  &:hover {
    color: var(--primary-color);
  }
  &:not(:first-child) {
    &::before {
      content: '';
      display: inline-block;
      margin: 0 6px;
      width: 1px;
      height: 8px;
      background-color: #333;
    }
  }
}
</style>
